export const getAccountGroupId = (node) => node?.AccGroupId ?? node?.Id;

export const isSameAccountGroupId = (left, right) => {
  if (left == null || right == null) return left === right;
  return String(left) === String(right);
};

export const findAccountGroupNode = (nodes, id) => {
  for (const node of nodes || []) {
    if (isSameAccountGroupId(getAccountGroupId(node), id)) return node;
    const child = findAccountGroupNode(node.Children, id);
    if (child) return child;
  }
  return null;
};

export const findAccountGroupParentNode = (nodes, id) => {
  for (const node of nodes || []) {
    if (
      (node.Children || []).some((child) =>
        isSameAccountGroupId(getAccountGroupId(child), id),
      )
    ) {
      return node;
    }
    const parent = findAccountGroupParentNode(node.Children, id);
    if (parent) return parent;
  }
  return null;
};

export const isAccountGroupDescendant = (nodes, currentNodeId, targetId) => {
  const current = findAccountGroupNode(nodes, currentNodeId);
  if (!current) return false;

  const containsTarget = (node) =>
    (node.Children || []).some(
      (child) =>
        isSameAccountGroupId(getAccountGroupId(child), targetId) ||
        containsTarget(child),
    );

  return containsTarget(current);
};

export const flattenAccountGroupMoveTargets = (
  nodes,
  movingGroupId,
  result = [],
  depth = 0,
) => {
  for (const node of nodes || []) {
    if (isSameAccountGroupId(getAccountGroupId(node), movingGroupId)) continue;
    result.push({
      ...node,
      Id: getAccountGroupId(node),
      AccGroupId: getAccountGroupId(node),
      AccGroupCode: node.AccGroupCode ?? node.GroupCode,
      AccGroupName: node.AccGroupName ?? node.GroupName,
      Account: node.Account || node.Accounts || node.AccCode,
      _depth: depth,
    });
    flattenAccountGroupMoveTargets(
      node.Children,
      movingGroupId,
      result,
      depth + 1,
    );
  }
  return result;
};
